module.exports = __webpack_public_path__ + "static/media/otcNewIcon.df90a744.png";